export default __webpack_public_path__ + "static/media/c++.a8b80bbf.png";